import { UndefinedOption } from '@df/ui/atomic/atomic-options';
import { NICmsContentField } from '@icms/core/content';

export namespace NCustomerGroups {
    export interface IOption extends NICmsContentField.IOption {}

    export type TId = number | 'not_logged_in' | 'all';

    export const NOT_LOGGED_IN_CUSTOMER_OPTION: IOption = {
        title: 'Not logged in',
        key: 'not_logged_in'
    };

    export const ALL_CUSTOMER_OPTION: IOption = {
        title: 'All',
        key: 'all'
    };
}

export const STAFF_CUSTOMER_GROUP_ID = 4;
export const STORE_STAFF_CUSTOMER_GROUP_ID = 14;
export const CUSTOMER_GROUPS: NCustomerGroups.IOption[] = [
    {
        title: 'General',
        key: 1
    },
    {
        title: 'Wholesale',
        key: 2
    },
    {
        title: 'Retailer',
        key: 3
    },
    {
        title: 'Staff',
        key: STAFF_CUSTOMER_GROUP_ID
    },
    {
        title: 'Customer service',
        key: 5
    },
    {
        title: 'Prezola 10%',
        key: 6
    },
    {
        title: 'Store personalisation admin',
        key: 7
    },
    {
        title: 'Promo testing',
        key: 8
    },
    {
        title: 'Press contacts',
        key: 9
    },
    {
        title: 'TCO TEST',
        key: 10
    },
    {
        title: 'PR VIPs',
        key: 11
    },
    {
        title: 'Press Influencer',
        key: 12
    },
    {
        title: 'Soft Customers',
        key: 13
    },
    {
        title: 'Store Staff',
        key: STORE_STAFF_CUSTOMER_GROUP_ID
    },
    {
        title: 'Trade',
        key: 15
    }
];

export const customerGroupVisibilityCmsField = (customerGroups: NCustomerGroups.IOption[] = [], multiple = true) => {
    const groups: NCustomerGroups.IOption[] = [
        NCustomerGroups.NOT_LOGGED_IN_CUSTOMER_OPTION,
        ...customerGroups,
        NCustomerGroups.ALL_CUSTOMER_OPTION
    ];

    return {
        key: 'visibility',
        type: NICmsContentField.EFieldType.choice,
        title: 'Visibility',
        options: () => {
            if (!multiple) {
                return [...UndefinedOption, ...groups];
            }

            return groups;
        },
        default: [NCustomerGroups.ALL_CUSTOMER_OPTION.key],
        multiple
    };
};

export function isCustomerAllowed(allowed: NCustomerGroups.TId | NCustomerGroups.TId[] | undefined, groupId?: number): boolean {
    const _allowed = Array.isArray(allowed) ? allowed : [allowed];

    if (_allowed.indexOf(NCustomerGroups.ALL_CUSTOMER_OPTION.key) > -1) {
        return true;
    }

    if (groupId) {
        return _allowed.indexOf(groupId) > -1;
    }

    return _allowed.indexOf(NCustomerGroups.NOT_LOGGED_IN_CUSTOMER_OPTION.key) > -1;
}
